import { SUCCESS_RESPONSES, TEXT_ALERT_MESSAGES_API } from 'constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(TEXT_ALERT_MESSAGES_API);
    const json = await response.json();
    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: false, json };
    return { ok: true, json };
  } catch (err) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
